/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} This_Light_Quail_HackInputs */

const fr_this_light_quail_hack = /** @type {(inputs: This_Light_Quail_HackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autorisé (surchargé)`)
};

/**

* @param {This_Light_Quail_HackInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const this_light_quail_hack = /** @type {((inputs?: This_Light_Quail_HackInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<This_Light_Quail_HackInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_this_light_quail_hack(inputs)
});